<script setup lang="ts">
    defineOptions({ name: 'AccountOrderSummary' });

    const { t } = useI18n();
</script>

<template>
    <div class="summary-header">
        <div class="number label">{{ t('account.order.orderNumber') }}</div>
        <div class="total label">{{ t('account.order.totalAmount') }}</div>
        <div class="date label">{{ t('account.order.orderDate') }}</div>
        <div class="status label">{{ t('account.order.orderStatus') }}</div>

        <slot />
    </div>
</template>

<style lang="scss">
    @import '~/assets/scss/checkout/checkout-order-summary.scss';
</style>
